<template>
    <div class="eta-display">
        <div class="eta-content">
            <div v-if="routeInfo">
                <div class="eta-item">
                    <span class="eta-label"> <span style="color: #1890ff;">{{ routeInfo.vehicleNo
                            }}</span> 预计到达时间:</span>
                    <span class="eta-value">{{ routeInfo.duration }}分钟</span>
                </div>
                <div class="eta-item">
                    <span class="eta-label">行驶距离:</span>
                    <span class="eta-value">{{ (routeInfo.distance / 1000).toFixed(1) }}公里</span>
                </div>
            </div>
            <div v-else>
                <span class="eta-label">正在获取车辆定位计算预计到达时间...</span>
            </div>
        </div>
        <button class="recalculate-btn" @click="handleRecalculate" :disabled="isCooldown">
            {{ isCooldown ? `请等待${cooldownSeconds}秒` : '更新数据' }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'EtaDisplay',
    props: {
        routeInfo: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isCooldown: false,
            cooldownSeconds: 0,
            cooldownTimer: null
        }
    },
    beforeDestroy() {
        if (this.cooldownTimer) {
            clearInterval(this.cooldownTimer);
        }
    },
    methods: {
        handleRecalculate() {
            if (this.isCooldown) return;

            // 触发父组件事件
            this.$emit('recalculate-route');

            // 开始冷却计时
            this.startCooldown();
        },

        startCooldown() {
            const cooldownTime = 5; // 3秒冷却时间
            this.isCooldown = true;
            this.cooldownSeconds = cooldownTime;

            this.cooldownTimer = setInterval(() => {
                this.cooldownSeconds--;

                if (this.cooldownSeconds <= 0) {
                    this.clearCooldown();
                }
            }, 1000);
        },
        clearCooldown() {
            this.isCooldown = false;
            this.cooldownSeconds = 0;
            clearInterval(this.cooldownTimer);
            this.cooldownTimer = null;
        }
    }
};
</script>

<style lang="less" scoped>
.eta-display {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
}

.eta-content {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px 20px;
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    min-width: 250px;
}

.eta-item {
    margin: 5px 0;
}

.eta-label {
    font-weight: bold;
    margin-right: 10px;
}

.eta-value {
    color: #1890ff;
}


.recalculate-btn {
    padding: 8px 16px;
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
    transition: all 0.3s;
}

.recalculate-btn:hover:not(:disabled) {
    background-color: #66b1ff;
}

.recalculate-btn:disabled {
    background-color: #c0c4cc;
    cursor: not-allowed;
}
</style>